import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { ApiError } from '../../types/Error';
import { LoggerCheckResponse, RunLoggerCheckParams } from '../../types/Logger';
import { runLoggerCheck } from '../LoggerCheck';

export const useRunLoggerCheckMutation = (
    options?: UseMutationOptions<LoggerCheckResponse, ApiError, RunLoggerCheckParams>
) => useMutation({ mutationFn: runLoggerCheck, ...options });
